import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, FileText, Repeat, Archive, Network, Zap } from 'lucide-react';
import { VALUE_PROPS } from '../config/siteContent';

const ICONS = { Headphones, FileText, Repeat, Archive, Network, Zap };

/**
 * ValueProps - light theme.
 * 6-up grid of "Why iConnect" cards with sky-tile icons.
 */
const ValueProps = () => {
  return (
    <section id="why-iconnect" className="relative py-24 lg:py-32 bg-bg-canvas">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-3xl xl:max-w-none mx-auto"
        >
          <p className="eyebrow">Why iConnect</p>
          {/* Trimmed to fit one line at full 60px within the section's max width
              on desktop; wraps to two lines on narrower laptops/phones (no overflow). */}
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-text-primary mb-4 tracking-[-0.02em] text-balance">
            <span className="text-gradient-sky">EDI capabilities</span>{' '}
            you need, without complexity
          </h2>
          <p className="text-lg text-text-secondary text-pretty">
            Built on 25+ years of EDI expertise - we sweat the details so you can focus on
            growing your business.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {VALUE_PROPS.map((prop, idx) => {
            const Icon = ICONS[prop.icon] || Zap;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                whileHover={{ y: -4 }}
                className="card-elevated p-6 lg:p-7"
              >
                <div className="w-11 h-11 rounded-lg bg-gradient-sky shadow-glow-sky flex items-center justify-center mb-4">
                  <Icon size={20} className="text-white" />
                </div>
                <h3 className="font-display font-bold text-lg text-text-primary mb-2">
                  {prop.title}
                </h3>
                <p className="text-text-secondary text-sm leading-relaxed">
                  {prop.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;
